/**gestione del banner cliccabile**/
// Aggiungi un listener per rendere il banner cliccabile
document.addEventListener("DOMContentLoaded", function () {
  // Trova l'elemento del banner
  const banner = document.querySelector(".mob__announcement-links");

  // Controlla se l'elemento esiste per evitare errori
  if (banner) {
    // Aggiungi un event listener per il click
    banner.addEventListener("click", function () {
      // Reindirizza all'URL desiderato
      window.location.href = "https://de-core.it/collections/piante-finte";
    });

    // Assicurati che il cursore indichi che l'area è cliccabile
    banner.style.cursor = "pointer";
  }
});


/**gestione dell'h5 sotto newsletter**/
document.addEventListener('DOMContentLoaded', function () {
    const h5Element = document.querySelector('.footer-col .rte h5');
    const formElement = document.querySelector('.footer-col .form');
    if (h5Element && formElement) {
        formElement.parentNode.insertBefore(h5Element, formElement.nextSibling);
    }
});
/**gestione dei filtri**/

document.addEventListener('DOMContentLoaded', function () {
    let lastScrollY = window.scrollY;
    const filterBar = document.querySelector('.filter-bar');

    window.addEventListener('scroll', function () {
        if (window.scrollY > lastScrollY) {
            filterBar.style.transform = 'translateY(-100%)';
        } else {
            filterBar.style.transform = 'translateY(0)';
        }
        lastScrollY = window.scrollY;
    });
});
/**gestione della barra search solo da mobile solo su home**/
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) { // Controllo per dispositivi mobili (larghezza max 768px)
    const searchBar = document.querySelector('.header__search');
    if (searchBar && window.location.pathname !== "/") {
      searchBar.style.display = "none"; // Nascondi la barra di ricerca se non sei nella home
    }
  }
});

/*gesione menu footer sempre aperto*/

document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll("footer details");

  if (window.innerWidth <= 768) {
    detailsElements.forEach((detail) => {
      detail.setAttribute("open", "");
      detail.style.display = "block";
      detail.style.visibility = "visible";
    });

    const summaryElements = document.querySelectorAll("footer details summary");
    summaryElements.forEach((summary) => {
      summary.style.display = "block";
      summary.style.cursor = "default";
      summary.addEventListener("click", (event) => {
        event.stopPropagation();
        event.preventDefault();
      });
    });
  }
});

/**gestione numero recensioni*/
document.addEventListener("DOMContentLoaded", function() {
  // Leggi il numero di recensioni
  var reviewElement = document.querySelector('.jdgm-carousel-number-of-reviews');
  var reviewCount = reviewElement.getAttribute('data-number-of-reviews');
  var placeholder = document.getElementById('review-placeholder');
  placeholder.textContent = 'Da ' + reviewCount + ' recensioni verificate!';
  
  // Leggi la media delle recensioni
  var averageElement = document.querySelector('.jdgm-all-reviews-rating');
  var averageScore = averageElement.getAttribute('data-score');
  var averagePlaceholder = document.getElementById('average-rating-placeholder');
  averagePlaceholder.textContent = 'Valutazione ' + averageScore;
});


